import { getSierraSecrets } from './getSierraSecrets.ts';

import { type SierraAPIConfig } from '../types/SierraAPIConfig.ts';

type SierraSecrets = {
    USER_TOKEN?: string;
    SELLER_TOKEN?: string;
    SALESFORCE_CUSTOMER_IDENTITY_TOKEN?: string;
};

function getSierraSecretsConfig({
    userToken,
    sellerToken,
    sfChatToken,
    onSfChatTokenRefresh,
}: {
    userToken: string | null | undefined;
    sellerToken: string | null | undefined;
    sfChatToken: string | null | undefined;
    onSfChatTokenRefresh: () => string | null | Promise<string | null>;
}): {
    secrets: SierraAPIConfig['secrets'];
    onSecretExpiry: SierraAPIConfig['onSecretExpiry'];
} {
    return {
        secrets: getSierraSecrets({ userToken, sellerToken, sfChatToken }),
        onSecretExpiry: secretName => {
            const key = secretName as keyof SierraSecrets;
            if (key === 'SALESFORCE_CUSTOMER_IDENTITY_TOKEN') {
                return onSfChatTokenRefresh();
            }
            return null;
        },
    };
}

export { getSierraSecretsConfig, type SierraSecrets };
